// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";

/**
 * One endpoint a `ControlRoute` may write to.
 *
 * Targets are a separate table rather than a bare `[Uuid]` vector so a rule can
 * carry per-target ordering, and so a target can be disabled without
 * rewriting the rule's whole target list.
 */
export class ControlRouteTarget implements flatbuffers.IUnpackableObject<ControlRouteTargetT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): ControlRouteTarget {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsControlRouteTarget(
    bb: flatbuffers.ByteBuffer,
    obj?: ControlRouteTarget,
  ): ControlRouteTarget {
    return (obj || new ControlRouteTarget()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsControlRouteTarget(
    bb: flatbuffers.ByteBuffer,
    obj?: ControlRouteTarget,
  ): ControlRouteTarget {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new ControlRouteTarget()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  id(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  /**
   * Owning rule.
   */
  routeId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  /**
   * The `ChannelEndpoint` this target writes to. Must belong to the same
   * channel as the owning rule — enforced by `LiftCloud`, not by this schema.
   */
  endpointId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  /**
   * Position within the rule's target list. For `ControlFanOut.SINGLE` this
   * is the fallback order: ordinal 0 is tried first. For `ControlFanOut.ALL`
   * it only fixes a deterministic write order.
   */
  ordinal(): number {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  /**
   * Disables one target without deleting it. Inactive targets are skipped by
   * both fan-out modes.
   */
  active(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : true;
  }

  createdAt(): string | null;
  createdAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  createdAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  updatedAt(): string | null;
  updatedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  updatedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  static startControlRouteTarget(builder: flatbuffers.Builder) {
    builder.startObject(7);
  }

  static addId(builder: flatbuffers.Builder, idOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, idOffset, 0);
  }

  static addRouteId(builder: flatbuffers.Builder, routeIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, routeIdOffset, 0);
  }

  static addEndpointId(builder: flatbuffers.Builder, endpointIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, endpointIdOffset, 0);
  }

  static addOrdinal(builder: flatbuffers.Builder, ordinal: number) {
    builder.addFieldInt32(3, ordinal, 0);
  }

  static addActive(builder: flatbuffers.Builder, active: boolean) {
    builder.addFieldInt8(4, +active, +true);
  }

  static addCreatedAt(builder: flatbuffers.Builder, createdAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(5, createdAtOffset, 0);
  }

  static addUpdatedAt(builder: flatbuffers.Builder, updatedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(6, updatedAtOffset, 0);
  }

  static endControlRouteTarget(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // id
    builder.requiredField(offset, 6); // route_id
    builder.requiredField(offset, 8); // endpoint_id
    return offset;
  }

  unpack(): ControlRouteTargetT {
    return new ControlRouteTargetT(
      this.id() !== null ? this.id()!.unpack() : null,
      this.routeId() !== null ? this.routeId()!.unpack() : null,
      this.endpointId() !== null ? this.endpointId()!.unpack() : null,
      this.ordinal(),
      this.active(),
      this.createdAt(),
      this.updatedAt(),
    );
  }

  unpackTo(_o: ControlRouteTargetT): void {
    _o.id = this.id() !== null ? this.id()!.unpack() : null;
    _o.routeId = this.routeId() !== null ? this.routeId()!.unpack() : null;
    _o.endpointId = this.endpointId() !== null ? this.endpointId()!.unpack() : null;
    _o.ordinal = this.ordinal();
    _o.active = this.active();
    _o.createdAt = this.createdAt();
    _o.updatedAt = this.updatedAt();
  }

  unpackFields(...fields: string[]): ControlRouteTargetT {
    const t = new ControlRouteTargetT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("id")) {
      t.id = this.id() !== null ? this.id()!.unpack() : null;
    }
    if (fieldSet.has("route_id")) {
      t.routeId = this.routeId() !== null ? this.routeId()!.unpack() : null;
    }
    if (fieldSet.has("endpoint_id")) {
      t.endpointId = this.endpointId() !== null ? this.endpointId()!.unpack() : null;
    }
    if (fieldSet.has("ordinal")) {
      t.ordinal = this.ordinal();
    }
    if (fieldSet.has("active")) {
      t.active = this.active();
    }
    if (fieldSet.has("created_at")) {
      t.createdAt = this.createdAt();
    }
    if (fieldSet.has("updated_at")) {
      t.updatedAt = this.updatedAt();
    }
    return t;
  }
}

export class ControlRouteTargetT implements flatbuffers.IGeneratedObject {
  constructor(
    public id: UuidT | null = null,
    public routeId: UuidT | null = null,
    public endpointId: UuidT | null = null,
    public ordinal: number = 0,
    public active: boolean = true,
    public createdAt: string | Uint8Array | null = null,
    public updatedAt: string | Uint8Array | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.id === null || this.id === undefined) {
      throw new Error('Required field "id" is not set');
    }
    if (this.routeId === null || this.routeId === undefined) {
      throw new Error('Required field "route_id" is not set');
    }
    if (this.endpointId === null || this.endpointId === undefined) {
      throw new Error('Required field "endpoint_id" is not set');
    }
    const id = this.id !== null ? this.id!.pack(builder) : 0;
    const routeId = this.routeId !== null ? this.routeId!.pack(builder) : 0;
    const endpointId = this.endpointId !== null ? this.endpointId!.pack(builder) : 0;
    const createdAt = this.createdAt !== null ? builder.createString(this.createdAt!) : 0;
    const updatedAt = this.updatedAt !== null ? builder.createString(this.updatedAt!) : 0;

    ControlRouteTarget.startControlRouteTarget(builder);
    ControlRouteTarget.addId(builder, id);
    ControlRouteTarget.addRouteId(builder, routeId);
    ControlRouteTarget.addEndpointId(builder, endpointId);
    ControlRouteTarget.addOrdinal(builder, this.ordinal);
    ControlRouteTarget.addActive(builder, this.active);
    ControlRouteTarget.addCreatedAt(builder, createdAt);
    ControlRouteTarget.addUpdatedAt(builder, updatedAt);

    return ControlRouteTarget.endControlRouteTarget(builder);
  }

  clone(): ControlRouteTargetT {
    const obj = new ControlRouteTargetT();
    obj.id = this.id !== null ? this.id!.clone() : null;
    obj.routeId = this.routeId !== null ? this.routeId!.clone() : null;
    obj.endpointId = this.endpointId !== null ? this.endpointId!.clone() : null;
    obj.ordinal = this.ordinal;
    obj.active = this.active;
    obj.createdAt = this.createdAt;
    obj.updatedAt = this.updatedAt;
    return obj;
  }

  equals(other: ControlRouteTargetT): boolean {
    if (this.id !== null && other.id !== null) {
      if (!this.id!.equals(other.id!)) return false;
    } else if (this.id !== other.id) return false;
    if (this.routeId !== null && other.routeId !== null) {
      if (!this.routeId!.equals(other.routeId!)) return false;
    } else if (this.routeId !== other.routeId) return false;
    if (this.endpointId !== null && other.endpointId !== null) {
      if (!this.endpointId!.equals(other.endpointId!)) return false;
    } else if (this.endpointId !== other.endpointId) return false;
    if (this.ordinal !== other.ordinal) return false;
    if (this.active !== other.active) return false;
    if (this.createdAt !== other.createdAt) return false;
    if (this.updatedAt !== other.updatedAt) return false;
    return true;
  }
}

export function verifyControlRouteTarget(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "id");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 6);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "route_id");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 8);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 8, "endpoint_id");
    verifier.checkScalarField(tablePos, 10, 4);
    verifier.checkScalarField(tablePos, 12, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 14);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 16);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
